import { render } from "./LearnByDoing.vue?vue&type=template&id=334e24da"
import script from "./LearnByDoing.vue?vue&type=script&lang=js"
export * from "./LearnByDoing.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__